<template>
    <div
        v-if="type && type !== 'none'"
        class="section-divider"
        :class="[
            `section-divider--${type}`,
            { 'section-divider--flip': flip },
        ]"
    >
        <!-- SVG shape dividers -->
        <svg
            v-if="type === 'wave'"
            class="section-divider__svg"
            viewBox="0 0 1440 120"
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :fill="color"
                d="M0,64 C360,120 720,0 1080,64 C1260,96 1380,80 1440,64 L1440,120 L0,120 Z"
            />
        </svg>

        <svg
            v-else-if="type === 'curve'"
            class="section-divider__svg"
            viewBox="0 0 1440 120"
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :fill="color"
                d="M0,120 C480,0 960,0 1440,120 L1440,120 L0,120 Z"
            />
        </svg>

        <svg
            v-else-if="type === 'slant'"
            class="section-divider__svg"
            viewBox="0 0 1440 120"
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <polygon
                :fill="color"
                points="0,120 1440,0 1440,120"
            />
        </svg>

        <svg
            v-else-if="type === 'zigzag'"
            class="section-divider__svg"
            viewBox="0 0 1440 120"
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <polygon
                :fill="color"
                points="0,120 180,40 360,120 540,40 720,120 900,40 1080,120 1260,40 1440,120"
            />
        </svg>

        <svg
            v-else-if="type === 'arrow'"
            class="section-divider__svg"
            viewBox="0 0 1440 120"
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <polygon
                :fill="color"
                points="0,120 720,0 1440,120"
            />
        </svg>

        <!-- Gradient fade divider -->
        <div
            v-else-if="type === 'gradient'"
            class="section-divider__gradient"
            :style="{
                background: `linear-gradient(to bottom, ${gradientFrom}, ${color})`,
            }"
        ></div>
    </div>
</template>

<script>
export default {
    name: 'SectionDivider',
    props: {
        type: {
            type: String,
            default: 'none',
            validator: (v) => ['none', 'wave', 'curve', 'slant', 'zigzag', 'arrow', 'gradient'].includes(v),
        },
        color: {
            type: String,
            default: '#ffffff',
        },
        gradientFrom: {
            type: String,
            default: 'transparent',
        },
        flip: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style>
.section-divider {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    line-height: 0;
    overflow: hidden;
    z-index: 5;
    pointer-events: none;
}
.section-divider--flip {
    transform: scaleY(-1);
}
.section-divider__svg {
    display: block;
    width: 100%;
    height: 60px;
}
@media (min-width: 768px) {
    .section-divider__svg {
        height: 90px;
    }
}
.section-divider__gradient {
    width: 100%;
    height: 80px;
}
@media (min-width: 768px) {
    .section-divider__gradient {
        height: 120px;
    }
}
</style>
